import { MdOutlineInput } from 'react-icons/md';

import { MenuContainer } from './style';
import { FLOW_TYPE } from 'constants/flow';
import { DataBlocks, EditorLeftSideBarMenuProps } from 'types';
import useMenuBlocks from '../hooks/useMenuBlocks';
import { createDataNodeDragData } from 'pages/Editor/utils/createNodeDragData';
import MenuBlock from './MenuBlock';

const DataMenu = ({ keyword, blocks }: EditorLeftSideBarMenuProps<DataBlocks>) => {
  const { filteredBlocks, onBlockDragStart } = useMenuBlocks({
    blocks: [...blocks.csv, ...blocks.image],
    keyword,
    nodeType: FLOW_TYPE.NODE.NEW_NODE,
  });

  return (
    <MenuContainer>
      {filteredBlocks.map((blockData) => (
        <MenuBlock
          key={`data/${blockData.name}`}
          blockColor="#a0a0a7"
          name={blockData.name}
          Icon={MdOutlineInput}
          onDragStart={(event) => onBlockDragStart(event, createDataNodeDragData({ blockData }))}
        />
      ))}
    </MenuContainer>
  );
};

export default DataMenu;
